/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAccountRequest
 */
export interface UpdateAccountRequest {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    readonly $schema?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    email: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAccountRequest
     */
    favoriteTeamId: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    username: string;
}

/**
 * Check if a given object implements the UpdateAccountRequest interface.
 */
export function instanceOfUpdateAccountRequest(value: object): value is UpdateAccountRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('favoriteTeamId' in value) || value['favoriteTeamId'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    return true;
}

export function UpdateAccountRequestFromJSON(json: any): UpdateAccountRequest {
    return UpdateAccountRequestFromJSONTyped(json, false);
}

export function UpdateAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'email': json['email'],
        'favoriteTeamId': json['favorite_team_id'],
        'username': json['username'],
    };
}

export function UpdateAccountRequestToJSON(json: any): UpdateAccountRequest {
    return UpdateAccountRequestToJSONTyped(json, false);
}

export function UpdateAccountRequestToJSONTyped(value?: Omit<UpdateAccountRequest, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'favorite_team_id': value['favoriteTeamId'],
        'username': value['username'],
    };
}

